import { render, staticRenderFns } from "./IntegrationsSiriusPage.vue?vue&type=template&id=6f9fb850"
import script from "./IntegrationsSiriusPage.vue?vue&type=script&lang=js"
export * from "./IntegrationsSiriusPage.vue?vue&type=script&lang=js"
import style0 from "./IntegrationsSiriusPage.vue?vue&type=style&index=0&id=6f9fb850&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports